(() => {
  const initFilterToggle = () => {
    const toggleComponent = document.querySelector('.algolia-collection');
    if (!toggleComponent) return;

    const checkInput = toggleComponent.querySelector(
      '.js-filter-header__filter .toggle__input--hidden'
    );
    const toggleInput = toggleComponent.querySelector('.js-filter-header__filter .toggle__input');
    const verticalFilter = document.querySelector('.products__vertical-filter');

    if (!checkInput || !toggleInput || !verticalFilter) {
      verticalFilter?.classList.remove('hidden');
      return;
    }

    toggleComponent.verticalFilter = verticalFilter;

    const filterState = localStorage.getItem('filterOpen');

    if (filterState === 'open' || filterState === null) {
      checkInput.checked = true;
      verticalFilter.classList.remove('hidden');
      toggleInput.classList.add('toggle__input--active');
    } else if (filterState === 'close') {
      checkInput.checked = false;
      verticalFilter.classList.add('hidden');
      toggleInput.classList.remove('toggle__input--active');
    }

    checkInput.addEventListener('change', (e) => {
      if (e.target.checked) {
        verticalFilter.classList.remove('hidden');
        localStorage.setItem('filterOpen', 'open');
      } else {
        verticalFilter.classList.add('hidden');
        localStorage.setItem('filterOpen', 'close');
      }
    });

    checkInput.addEventListener('change', () => {
      toggleInput.classList.toggle('toggle__input--active', checkInput.checked);
    });

    toggleInput.addEventListener('click', (e) => {
      if (e.target === checkInput) return;
      checkInput.checked = !checkInput.checked;
      checkInput.dispatchEvent(new Event('change'));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterToggle);
  } else {
    initFilterToggle();
  }

  window.initFilterToggle = initFilterToggle;
})();

class ToggleComponent extends HTMLElement {
  connectedCallback() {
    // Listen for the checkbox input change within the component
    this.checkInput = this.querySelector('.toggle__input--hidden');
    this.toggleInput = this.querySelector('.toggle__input');
    this._onChange = this.handleToggle.bind(this);
    if (this.checkInput && this.toggleInput) {
      this.checkInput.addEventListener('change', this._onChange);
    }
  }
  handleToggle() {
    // Toggle the active class based on the checkbox's checked state
    if (this.toggleInput && this.checkInput) {
      this.toggleInput.classList.toggle('toggle__input--active', this.checkInput.checked);
    }
  }
  disconnectedCallback() {
    // Optionally, remove event listeners if needed for cleanup
    if (this.checkInput && this.toggleInput) {
      this.checkInput.removeEventListener('change', this._onChange);
    }
  }
}

// Register the custom element

if (!customElements.get('toggle-component')) {
  customElements.define('toggle-component', ToggleComponent);
}

class FilterHeader extends HTMLElement {
  connectedCallback() {
    if (!this.classList.contains('show_mobile_sticky')) return;

    this.pagination = document.querySelector('#pagination');
    if (!this.pagination) return;

    this.isActive = false;
    this.ticking = false;

    this.updateTriggerPoint();

    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });

    this.check(); // initial
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
  }

  /* -------------------------
   * Core Logic
   * ------------------------- */

  check() {
    if (!this.pagination) return;

    if (window.innerWidth >= 1024) {
      this.setActive(false);
      return;
    }

    const scrollY = window.scrollY;
    const rect = this.pagination.getBoundingClientRect();

    const paginationVisible = this.isPaginationVisible(rect);
    const belowPagination = this.isBelowPagination(rect);
    const pastTrigger = this.isPastTrigger(scrollY);

    const shouldBeActive = pastTrigger && !paginationVisible && !belowPagination;

    this.setActive(shouldBeActive);
  }

  /* -------------------------
   * State Helpers
   * ------------------------- */

  isPaginationVisible(rect) {
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  isBelowPagination(rect) {
    return rect.bottom <= 0;
  }

  isPastTrigger(scrollY) {
    return scrollY >= this.triggerPoint;
  }

  /* -------------------------
   * DOM Updates
   * ------------------------- */

  setActive(nextState) {
    if (this.isActive === nextState) return;

    this.isActive = nextState;
    this.classList.toggle('active', nextState);
  }

  /* -------------------------
   * Events
   * ------------------------- */

  onScroll() {
    if (this.ticking) return;

    this.ticking = true;

    requestAnimationFrame(() => {
      this.check();
      this.ticking = false;
    });
  }

  onResize() {
    if (window.innerWidth >= 1024) {
      this.setActive(false);
      return;
    }

    this.updateTriggerPoint();
    this.check();
  }

  /* -------------------------
   * Utils
   * ------------------------- */

  updateTriggerPoint() {
    this.triggerPoint = this.getBoundingClientRect().top + window.scrollY;
  }
}

if (!customElements.get('filter-header')) {
  customElements.define('filter-header', FilterHeader);
}
